import { NotificationState } from './notification.model';

export const INITIAL_NOTIFICATION_STATE: NotificationState = {
  notifications: [],
  unseenCount: 0,
  loading: false,
  error: null,
};
